import React, { useState, useEffect } from 'react';
import { Box, Typography } from '@mui/material';
import { fetchCasts, deleteCast } from '../../utils/api';
import MasterDataTable from '../../components/MasterDataTable';

const columns = [
  { id: 'castId', label: 'ID', minWidth: 50 },
  { id: 'castName', label: 'Caste Name', minWidth: 170 },
  { 
    id: 'category', 
    label: 'Category', 
    minWidth: 170,
    format: (value) => value?.categoryName || '-'
  },
  { id: 'description', label: 'Description', minWidth: 300 },
];

const CastList = ({ onEdit, searchQuery = '' }) => {
  const [casts, setCasts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [refreshTrigger, setRefreshTrigger] = useState(0);

  useEffect(() => {
    let cancelled = false;
    const loadCasts = async () => {
      setLoading(true);
      try {
        const response = await fetchCasts();
        if (cancelled) return;
        setCasts(response.data);
        setError(null);
      } catch (err) {
        console.error('Error fetching casts:', err);
        if (!cancelled) {
          setError('Failed to load castes. Please try again later.');
          setCasts([]);
        }
      } finally {
        if (!cancelled) setLoading(false);
      }
    };

    loadCasts();
    return () => {
      cancelled = true;
    };
  }, [refreshTrigger]);

  const handleDelete = async (cast) => {
    try {
      await deleteCast(cast.castId, {
        previousData: cast,
        identifier: cast.castName
      });
      setRefreshTrigger(prev => prev + 1);
    } catch (err) {
      console.error('Error deleting caste:', err);
      alert('Failed to delete caste. It may be referenced by other records.');
    }
  };

  return (
    <Box>
      <Typography variant="h6" gutterBottom>
        Castes
      </Typography>
      
      <MasterDataTable
        persistKey="cast"
        data={casts}
        columns={columns}
        isLoading={loading}
        searchQuery={searchQuery}
        onEdit={onEdit}
        onDelete={handleDelete}
        emptyMessage="No castes found. Add your first caste!"
      />
      
      {error && (
        <Typography color="error" sx={{ mt: 2 }}>
          {error}
        </Typography>
      )}
    </Box>
  );
};

export default CastList; 